// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__9hHy9","footer":"ReportModalFilter_footer__1UQUG"};